@if (selectedSize() === visualsDashboardWidgetSizingEnum.SMALL) {
    <div class="row-container small">
        <app-ice-visuals-dashboard-pie-chart
            [segments]="sizeScoreByPhotosSegments()"
            [centerLabel]="sizeScoreByPhotosCenterLabel()"
            [loading]="dataService.loading()"
            [variant]="pieChartVariantEnum.SMALL"
        >
            <span chartFooter>{{ 'dashboard.visuals.components.general.average' | translate: { averageSize: averageSize() } }}</span>
        </app-ice-visuals-dashboard-pie-chart>
    </div>
} @else if (selectedSize() === visualsDashboardWidgetSizingEnum.MEDIUM_ROW) {
    <app-ice-visuals-dashboard-pie-chart
        [segments]="sizeScoreByPhotosSegments()"
        [centerLabel]="sizeScoreByPhotosCenterLabel()"
        [labelColumnHeader]="'dashboard.visuals.widgets.sizeScoreByPhotos.size' | translate"
        [valueColumnHeader]="'dashboard.visuals.widgets.sizeScoreByPhotos.tableLabel' | translate"
        [loading]="dataService.loading()"
        [variant]="pieChartVariantEnum.LARGE"
    >
        <span chartFooter>{{ 'dashboard.visuals.components.general.average' | translate: { averageSize: averageSize() } }}</span>
    </app-ice-visuals-dashboard-pie-chart>
}
